export default __webpack_public_path__ + "static/media/auto-code.50dab383.svg";